import React, { lazy, Suspense } from "react";
const LazyHRForms = lazy(() => import("./HRForms"));
const LazyListAcceptRequest = lazy(() => import("./ListAcceptRequest"));
const LazyListRejectRequest = lazy(() => import("./ListRejectRequest"));
const LazyListRequests = lazy(() => import("./ListRequests"));
const LazyPrintViewHrForm = lazy(() => import("./PrintViewHrForm"));
export const ListRequests = () => (
  <Suspense fallback="loading...">
    <LazyListRequests />
  </Suspense>
);
export const ListRejectRequest = () => (
  <Suspense fallback="loading...">
    <LazyListRejectRequest />
  </Suspense>
);
export const ListAcceptRequest = () => (
  <Suspense fallback="loading...">
    <LazyListAcceptRequest />
  </Suspense>
);
export const HRForms = () => (
  <Suspense fallback="loading...">
    <LazyHRForms />
  </Suspense>
);
export const PrintViewHrForm = () => (
  <Suspense fallback="loading...">
    <LazyPrintViewHrForm />
  </Suspense>
);
